export enum ViewType {
	Demos = 'demos',
	Leaderboard = 'leaderboard',
	Prizes = 'prizes',
}
